import { dashesOrNum, formatPercentage } from '@cast/utils';

export type ResourceType = 'cpu' | 'memory' | 'storage' | 'gpu';

export type ResourceChartPoint = {
  timestamp: string;
  chartTimestampUnix: number;
  provisioned: number;
  requested: number;
  requestedGap: number;
  used: number;
  utilization: number;
};

/** Current spend broken down by node lifecycle (on-demand / spot / fallback). */
export type SpendBreakdownChartPoint = {
  timestamp: string;
  chartTimestampUnix: number;
  onDemand: number;
  spot: number;
  fallback: number;
  total: number;
};

export const getResourceUnit = (resourceType: ResourceType): string => {
  switch (resourceType) {
    case 'cpu':
      return 'vCPU';
    case 'memory':
    case 'storage':
      return 'GiB';
    case 'gpu':
      return 'GPU';
  }
};

export const getResourceSeriesLabel = (resourceType: ResourceType): string =>
  resourceType === 'storage' ? 'Claimed' : 'Used';

export const getResourceRoundBy = (resourceType: ResourceType): number =>
  resourceType === 'cpu' ? 0 : 1;

export const fmtEstimatedResourceValue = (
  value: number | null | undefined,
  roundBy: number
): string => {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }

  return `~${dashesOrNum({ value, roundBy, decimals: roundBy })}`;
};

export const fmtEstimatedUtilizationValue = (value: number | null): string => {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }

  return `~${formatPercentage(value, { roundBy: 1 }).replace('%', '')}`;
};
